import React from "react";
import { Select } from "antd";
import { DATA } from "../../../myanfinviz";
import * as _ from "lodash";
const { Option } = Select;

export const SelectData = (props) => {
  const { size, onChange, defaultValue } = props;
  return (
    <Select
      {...props}
      size={size || "large"}
      showSearch
      defaultValue={defaultValue || ""}
      style={{ width: "100%" }}
      placeholder="Search"
      optionFilterProp="children"
      onChange={onChange && onChange}
      filterOption={(input, option) =>
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      {_.map(DATA, (record) => {
        const val = record["Company Name In Myanmar"];
        return (
          <Option key={val} value={`${val}`}>
            {val}
          </Option>
        );
      })}
    </Select>
  );
};
